import React, { useState } from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import successIcon from "../../../assets/images/success-icon.svg";
import "./change-password.scss";
import { ChangePasswordData } from "../../Login/interface";
import HelperService from "../../../Services/HelperService";
import { Label } from "../../Common/Label/Label";
import WebService from "../../../Services/WebService";
import { toast } from "react-toastify";
import { validatePassword } from "../../../Services/CommonFunction";
interface PropsData {
  handleClose: () => void;
}
const ChangePassword = ({ handleClose }: PropsData) => {
  const [errorFlag, setErrorFlag] = useState(false);
  const [changePasswordData, setChangePasswordData] =
    useState<ChangePasswordData>({
      current_password: "",
      password: "",
      confirm_password: "",
    });
  const [type, setType] = useState<string[]>([
    "password",
    "password",
    "password",
  ]);
  const [icon, setIcon] = useState<any[]>([BsEyeSlash, BsEyeSlash, BsEyeSlash]);

  const handleToggle = (index: number) => {
    if (type[index] === "password") {
      setIcon((prevIcons: any[]) => {
        return prevIcons.map((item, iconIndex) =>
          index === iconIndex ? BsEye : item
        );
      });
      setType((prevIcons: any[]) => {
        return prevIcons.map((item, typeIndex) =>
          index === typeIndex ? "text" : item
        );
      });
    } else {
      setIcon((prevIcons: any[]) => {
        return prevIcons.map((item, iconIndex) =>
          index === iconIndex ? BsEyeSlash : item
        );
      });
      setType((prevIcons: any[]) => {
        return prevIcons.map((item, typeIndex) =>
          index === typeIndex ? "password" : item
        );
      });
    }
  };

  const [showModal1, setShowModal1] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;
    setChangePasswordData((preVpassword: ChangePasswordData) => ({
      ...preVpassword,
      [name]: value,
    }));
  };
  const isPasswordInvalid =
    changePasswordData?.password.length > 0 && !validatePassword(changePasswordData?.password);

  const passwordError =
    isPasswordInvalid
      ? "Password must be at least 8 characters and include uppercase, lowercase, number and special character."
      : "";

  const isConfirmPasswordInvalid =
    changePasswordData?.confirm_password?.length > 0 &&
    changePasswordData?.confirm_password !== changePasswordData?.password;

  const confirmPasswordError = isConfirmPasswordInvalid
    ? "Password and confirm password do not match"
    : "";

  const handleChangePAssword = () => {
    if (
      changePasswordData?.confirm_password === "" ||
      changePasswordData?.current_password === "" ||
      changePasswordData?.password === ""
    ) {

      setErrorFlag(true);
      return;
    } else if (isPasswordInvalid) {
      setErrorFlag(true);
      return;
    } else if (
      isConfirmPasswordInvalid
    ) {
      setErrorFlag(true);
      return;
    } else {
      handleChangePasswordApiCall();
      setErrorFlag(false);
    }
  };
  const handleChangePasswordApiCall = () => {
    WebService.addLoader("change_password");
    return WebService.postAPI({
      action: `update-password`,
      body: changePasswordData,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status === true) {

          toast.success(res.message?.message);
          WebService.removeLoader("change_password");
          handleClose();
        } else {
          toast.error(res.message?.message);
          WebService.removeLoader("change_password");
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        WebService.removeLoader("change_password");
        return error;
      });
  };
  return (
    <>
      <section className="change-password-page">
        <Row>
          <Col lg={12} sm={12} className="mx-auto">
            <div className="">
              <p>Please choose a strong password for your account.</p>
              <div className="text-start position-relative mb-3">
                <label className="text-start">Current Password</label>
                <Form.Control
                  type={type[0]}
                  placeholder="Enter current password"
                  name="current_password"
                  onChange={handleChange}
                  autoComplete="off"
                />
                <span
                  className="input-group-text text-secondary border-0 cursor-pointer bseye"
                  onClick={() => handleToggle(0)}
                >
                  <span>{React.createElement(icon[0], { size: 18 })}</span>
                </span>
                {errorFlag && changePasswordData?.current_password === "" && (
                  <Label
                    title="Please enter current password"
                    modeError={true}
                  />
                )}
              </div>
              <div className="text-start position-relative mb-3">
                <label className="text-start">New Password</label>
                <Form.Control
                  type={type[1]}
                  placeholder="Enter new password"
                  name="password"
                  onChange={handleChange}
                  autoComplete="off"
                />
                <span
                  className="input-group-text text-secondary border-0 cursor-pointer bseye"
                  onClick={() => handleToggle(1)}
                >
                  <span>{React.createElement(icon[1], { size: 18 })}</span>
                </span>
                <label className="font-12 text-danger">
                  {passwordError}
                </label>
                {errorFlag && changePasswordData?.password === "" && (
                  <Label title="Please enter new password" modeError={true} />
                )}
                {/* {errorFlag &&
                  changePasswordData?.password &&
                  !HelperService.isValidPassword(
                    changePasswordData?.password
                  ) && (
                    <Label
                      title="Password must include uppercase, lowercase, number, and special character, and be at least 8 characters."
                      modeError={true}
                    />
                  )} */}
              </div>
              <div className="text-start position-relative mb-4">
                <label>Confirm Password</label>
                <Form.Control
                  type={type[2]}
                  placeholder="Enter confirm password"
                  name="confirm_password"
                  onChange={handleChange}
                  autoComplete="off"
                />
                <span
                  className="input-group-text text-secondary border-0 cursor-pointer bseye"
                  onClick={() => handleToggle(2)}
                >
                  <span>{React.createElement(icon[2], { size: 18 })}</span>
                </span>
                <label className="font-12 text-danger">
                  {confirmPasswordError}
                </label>
                {errorFlag && changePasswordData?.confirm_password === "" && (
                  <Label
                    title="Please enter confirm password"
                    modeError={true}
                  />
                )}
                {/* {errorFlag &&
                  changePasswordData?.confirm_password &&
                  changePasswordData?.password &&
                  changePasswordData?.confirm_password !==
                  changePasswordData?.password && (
                    <Label
                      title="New password & confirm password does not match!"
                      modeError={true}
                    />
                  )} */}
              </div>
              <button
                className="btn btn-primary w-100"
                type="button"
                id="change_password"
                onClick={handleChangePAssword}
              >
                Change Password{" "}
              </button>
            </div>
          </Col>
        </Row>
      </section>

      {/* Success Modal */}
      <Modal
        show={showModal1}
        onHide={() => setShowModal1(false)}
        size="sm"
        centered
      >
        <Modal.Header closeButton className="border-bottom-0 pb-0 pt-0">
          <Modal.Title>&nbsp;</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Form>
            <div className="login-form text-center">
              <p>
                <img src={successIcon} alt="" />
              </p>
              <h4 className="h4-title">Success!</h4>
              <p className="para mb-0"> Reset password successful. </p>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-top-0 pt-0 pb-3">
          <Button className="btn-primary w-100"> Login </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePassword;
